//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MHeader from '../Header/Header.vue';
import {aftersalesExchange} from '../../api';
export default {
    components: {
        MHeader
    },
    data(){
        return {
            item:""
        }
    },
    created(){
        let item = this.$route.params;
        console.log(item);
        this.$store.commit('showIsLoading');
        aftersalesExchange(item.id).then(res=>{
            if(res.data.error_code){
                alert(res.data.msg)
                console.error(res);
                return;
            };
            this.item = res.data.info;
            console.log(res);
        });
        console.log(this.item);
    },
    filters:{
        /*
            售后状态看status
            0 等待商家处理
            1 售后处理中
            2 售后成功
            3 售后驳回
        */
        statusName(index){
            switch (index-"") {
                case 0:
                    return '等待商家处理'
                    break;
                case 1:
                    return '售后处理中'
                    break;
                case 2:
                    return '售后成功'
                    break;
                case 2:
                    return '售后驳回'
                    break;
                default:
                    return '等待商家处理'
                    break;
            }
        },
        /*
            aftersales_type这个字段
            ONLY_REFUND 仅退款
            REFUND_GOODS 退货退款
            EXCHANGING_GOODS  申请换货
        */
        statusName2 (val){
            switch (val) {
                case 'ONLY_REFUND':
                    return '仅退款'
                    break;
                 case 'REFUND_GOODS':
                    return '退货退款'
                    break;
                 case 'EXCHANGING_GOODS':
                    return '申请换货'
                    break;
                default:
                    return '仅退款'
                    break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/OrderList/RefundDetail.vue